import React, { useContext, useEffect } from 'react';
import { Box, Link } from '@mui/material';
import { DefaultLayout, DefaultLayoutProps } from '_lex/_layouts/DefaultLayout';
import TopNav from './TopNav';
import { AppContext } from '../../../context';
import { translate as t } from 'hooks/useTranslations';
import SearchBar from '../../Policy/SearchManuals/_components/SearchBar';
import useModal from 'components/ContentEditor/hooks/useModal';
import { NavItem } from '_lex/_atoms/Sidebar';
import _ from 'lodash';

export interface CommonLayoutProps extends Omit<DefaultLayoutProps, 'navigationHeader' | 'sidebarItems'> {
  // Add any additional props specific to CommonLayout here
}

const CommonLayout: React.FC<CommonLayoutProps> = ({ children, ...props }) => {
  const { currentOrganizationId, hasPermission, sidebarItems, setBrowserTitle } = React.useContext(AppContext);
  const [modal, showModal] = useModal();

  useEffect(() => {
    if (props.headerProps?.title) {
      // If title is a string, use it directly, otherwise try to get text content
      const titleText =
        typeof props.headerProps.title === 'string'
          ? props.headerProps.title
          : (props.headerProps.title as any)?.props?.children || '';
      setBrowserTitle(titleText);
    }
  }, [props.headerProps?.title, setBrowserTitle]);

  const handleNavigate = (item: NavItem) => {
    if (item.key === 'searchManuals') {
      if (!hasPermission('listIssuedManuals', currentOrganizationId || '')) return;
      showModal(t('common.navItems.searchManuals.root'), (onClose) => <SearchBar onClose={onClose} />, {
        size: 'lg',
        sx: {
          '& .MuiDialogContent-root > .MuiStack-root': {
            padding: 0,
          },
        },
      });
    }
  };

  const footerContent = (
    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 4, width: '100%' }}>
      <Link
        href='https://www.lexipol.com/privacy-policy/'
        target='_blank'
      >
        {t('common.footer.privacy')}
      </Link>
      <Link
        href='https://www.lexipol.com/cookie-notice/'
        target='_blank'
      >
        {t('common.footer.cookie')}
      </Link>
      <Link
        href='https://www.lexipol.com/privacy-policy/#donotsell'
        target='_blank'
      >
        {t('common.footer.donotsell')}
      </Link>
    </Box>
  );

  React.useEffect(() => {
    const titleText = (props.pageTitle || props.headerProps?.title) as string;
    if (!_.isEmpty(titleText)) {
      document.title = titleText;
    } else {
      document.title = t('common.browserTitle');
    }
  }, [props.pageTitle, props.headerProps?.title]);

  return (
    <DefaultLayout
      navigationHeader={<TopNav />}
      sidebarItems={sidebarItems}
      footerContent={footerContent}
      onSidebarNavigate={handleNavigate}
      {...props}
    >
      {children}
      {modal}
    </DefaultLayout>
  );
};

export default CommonLayout;
